export default __webpack_public_path__ + "locales/lv/People.json?hash=8da92c33d14fa9522a3e75094d62e081";